import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { axios } from '../client';
import { GET_PROMOTIONS, getPromotions } from "../actions/promotion";

function* handleGetPromotions({meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let response;
    try {
        //Using just axios makes an unauthenticated call. If you need to be authenticated, use authenticatedAxious
        response = yield call(axios.get, `${window.api_url}/site/promotions`);
    } catch (error) {
        yield put(getPromotions(error, {}, true));
    }

    yield put(getPromotions({
        promotions: response.data
    }, {'sent': true}));
}
export function* watchGetPromotions() {
    yield takeLatest(GET_PROMOTIONS, handleGetPromotions);
}